import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { getPermissionFlags } from "utils/permissions";

export const useDivisionAdmin = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");
  const user = useSelector((state) => state.user);

  const { showOrg } = getPermissionFlags(user);

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentDivision, setCurrentDivision] = useState(null); // Store the division being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentDivision(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((division) => {
    setEditMode(true);
    setCurrentDivision(division);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isLargeScreen,
    open,
    editMode,
    currentDivision,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    showOrg,
  };
};
